angular.module('MW.InsDashboard.GoogleAccountService', [
    'MW.DashboardLegacy.Constants',
    'MW.Framework.CoreCompanyService',
    'MW.Framework.DialogService'
])
.factory('GoogleAccountService', [
    '$http',
    '$q',
    '$window',
    'CoreCompanyService',
    'DASHBOARD_LEGACY_VIEW_PATH',
    'DialogService',
    'GOOGLE_ACCOUNT_API',
    'GOOGLE_CLIENT_ID',
    function ($http,
        $q,
        $window,
        CoreCompanyService,
        DASHBOARD_LEGACY_VIEW_PATH,
        DialogService,
        GOOGLE_ACCOUNT_API,
        GOOGLE_CLIENT_ID) {
        'use strict';

        var _auth2,
            googleAuth,
            googleAccountService = {},
            isInitialized,
            isInitializedDeferred = $q.defer();

        isInitialized = isInitializedDeferred.promise;
        
        if(gapi !== undefined) {
            gapi.load('auth2', function () {
                _auth2 = gapi.auth2;

                _auth2.init({
                    client_id: GOOGLE_CLIENT_ID,
                    scope: 'profile email https://www.googleapis.com/auth/analytics.readonly'
                }).then(function onInit(gAuth) {
                    googleAuth = gAuth;
                    isInitializedDeferred.resolve(true);
                }, function onError(error) {
                    console.log('Error during Google Auth initialization: ', error);
                });
            });
        }

        /**
         * Responsible for authenticating a user by allowing them to sign in.  
         * We then save the google account data for future google account related uses.
         */
        googleAccountService.establishGoogleAccount = function establishGoogleAccount(){
            var establishGoogleAccountDeferred = $q.defer(),
                googleSigninUrl = GOOGLE_ACCOUNT_API + '/v1/signin',
                googleSigninPayload = {
                    code: '',
                    companyId: ''
                };

            googleAuth.grantOfflineAccess().then(function(response) {
                DialogService.dialog({
                    title: null,
                    template: DASHBOARD_LEGACY_VIEW_PATH + '/ins_dashboard/views/google_account_saving_dialog.html'
                });
                
                googleSigninPayload.code = response.code;

                CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                    googleSigninPayload.companyId = company._id;
                });
                
                $http.post(googleSigninUrl, googleSigninPayload).then(function successCallback(response) {
                    DialogService.closeDialog();
                    establishGoogleAccountDeferred.resolve(response);
                }, function errorCallback(error) {
                    DialogService.closeDialog();
                    establishGoogleAccountDeferred.reject(error);
                });
            });

            return establishGoogleAccountDeferred.promise;
        };

        /**
         * Responsible for getting the authenticated users profile information that we need to work with.
         * 
         * @return {Promise} The authenticated users profile information.
         */
        googleAccountService.getUserProfile = function getUserProfile() {
            var userProfileDeferred = $q.defer(),
                googleProfileUrl = GOOGLE_ACCOUNT_API + '/v1/profile?companyId=';

            CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                googleProfileUrl += company._id;
                $http.get(googleProfileUrl).then(function adaptUserInfo (response) {
                    userProfileDeferred.resolve(response.data);
                });
            });

            return userProfileDeferred.promise;
        };

        /**
         * Responsible for saving the google account data we need for account purposes.
         */
        function createGoogleAccount(googleAccount) {
            return $http.post(GOOGLE_ACCOUNT_API, googleAccount);
        };

        /**
         * Responsible for deleting the google account specified by the id argument
         */
        googleAccountService.deleteGoogleAccount = function deleteGoogleAccount(accountId) {
            var deleteUrl = GOOGLE_ACCOUNT_API + '/v1/' + accountId;

            return $http.delete(deleteUrl);
        };

        return googleAccountService;
    }
]);
